import React, { useState } from 'react';
import Client from '@cube3/state/src/wrapped-cube-client';
import { defaultConfig } from '@cube3/state/src/wrapped-cube-client/uploader/config';
import { ExtendedUpload } from '@cube3/state/src/wrapped-cube-client/uploader/extendedupload';

type TargetConfig = {
  targetResourceType: string;
  targetResourceId: string;
} & Record<string, string>;

export const useUploadImage = (config: TargetConfig) => {
  const [error, setError] = useState(undefined);
  const [status, setStatus] = useState<
    'uploading' | 'succeeded' | 'failed' | undefined
  >(undefined);

  const onUpload = React.useCallback(
    (src: string) => {
      const TOKEN = Client.auth.getAccessToken();
      if (!src) return;
      if (!TOKEN) {
        setError("You don't have permission to upload images");
        return;
      }
      setStatus('uploading');
      fetch(src)
        .then((res) => res.blob()) // convert the image to be a file
        .then((data) => {
          const upload = new ExtendedUpload(data, {
            ...defaultConfig,
            metadata: {
              ...defaultConfig.metadata,
              session_token: TOKEN,
              ...config
            },
            onError: (err) => {
              setError(err.message);
              setStatus('failed');
            },
            onSuccess: () => {
              setError(undefined);
              setStatus('succeeded');
            }
          });
          upload.start();
        });
    },
    [config]
  );

  return {
    error,
    status,
    onUpload,
    setError
  };
};
